<template>
  <!-- <div> -->
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      max-width="600px"
      style="
          border-radius: 26px;"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          @click.stop="dialog = true"
          small
          text
          class="ma-3"
          color="green darken-3"
          >ADD NOTE</v-btn
        >
      </template>
      <v-card
        class="ma-auto pa-2"
        flat
        filled
        style="
          border-radius: 26px;
          border: 1px solid #18CAE6;
          max-width: 600px;
          
        "
      >
        <v-card-title>
          <span>ADD </span><span class="red--text"> NOTE</span>
        </v-card-title>
        <v-form class="ma-2 pa-2" @submit.prevent="onAddNote" ref="form">
          <div>
            <v-card
              style="max-width: 500px"
              outlined
              tile
              rounded
              class="ma-auto"
              dense
            >
              <!-- <div>ADD A NEW NOTE</div> -->
              <div class="ma-2 mt-2">
                <v-textarea
                  class="ma-2 mt-6"
                  autofocus
                  outlined
                  v-model="content"
                  multiple
                  label="TYPE YOUR NOTE"
                  color="#2E5473"
                  dense
                  filled
                ></v-textarea>
                <v-autocomplete
                  clearable
                  deletable-chips
                  small-chips
                  chips
                  hide-selected
                  multiple
                  outlined
                  :items="options"
                  label="SELECT A TAG"
                  v-model="tags"
                  color="#2E5473"
                  dense
                  filled
                ></v-autocomplete>
              </div>
            </v-card>
          </div>
          <v-layout row class="mt-2">
            <v-spacer></v-spacer>
            <v-btn rounded text outlined @click="cancelDialog">CANCEL</v-btn>
            <v-spacer></v-spacer>
            <!-- <v-btn rounded text outlined @click="cancelDialog"></v-btn> -->
            <v-spacer></v-spacer>

            <v-btn
              rounded
              color="black"
              :disabled="!formIsValid"
              dark
              type="submit"
              >ADD</v-btn
            >
            <v-spacer></v-spacer>
          </v-layout>
        </v-form>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
/**
 * adds a note to the matter for other users with access to the matter to see and respond to
 */
import * as firebase from "firebase";
import * as moment from "moment";

export default {
  props: ["matter", "user"],
  data() {
    return {
      content: null,
      // attorneys: [],
      dialog: false,
      options: [
        "deadlines",
        "discovery",
        "client communication",
        "hearings",
        "court filings",
        "reminder"
      ],
      tags: []
    };
  },
  computed: {
    // user() {
    //   return this.$store.getters.user;
    // },
    // matter() {
    //   return this.$store.getters.;
    // },
    formIsValid() {
      return this.content !== null;
    },
    firm() {
      return this.$store.getters.firm;
    }
  },
  watch: {
    // name(val) {
    //   if (val !== null && val !== undefined) {
    //     this.existingAttorney = null;
    //   }
    // },
    // barNumber(val) {
    //   if (val !== null && val !== undefined) {
    //     this.existingAttorney = null;
    //   }
    // },
    // existingAttorney(val) {
    //   if (val !== null && val !== undefined) {
    //     this.name = null;
    //     this.barNumber = null;
    //   }
    // }
  },
  methods: {
    // onFilePicked() {
    //   if (event.target.files) {
    //     const fileList = Array.from(event.target.files);
    //     fileList.forEach(file => {
    //       this.initialDocs.push(file);
    //     });
    //   }
    // },

    // removeAttorney(index) {
    //   this.attorneys.splice(index, 1);
    // },

    //ADD DOCUMENT ATTACHEMENT CAPABILITIES
    logTags() {
      console.log(this.tags);
    },

    clearNote() {
      this.content = null;
      this.tags = [];
      this.dialog = false;
    },
    onAddNote() {
      if (this.formIsValid) {
        let note = {
          content: this.content,
          date: moment().format("MMMM Do YYYY, h:mm:ss a"),
          user: this.user,
          tags: this.tags,
          replies: []
        };

        // firebase
        //   .firestore()
        //   .collection("firms")
        //   .doc(this.user.firmSlug)
        //   .collection("matters")
        //   .doc(this.matter.matterSlug)
        //   .collection("notes")
        //   .add(note)
        //   .then(docRef => {
        //     //SAVE ATTACHEMENTS
        //     //GET URLS FOR ATTACHED DOCS
        //     //ADD URLS TO THE OBJECT AND SAVE T0 DB
        //     let id = docRef.id;
        //     firebase
        //       .firestore()
        //       .collection("firms")
        //       .doc(this.user.firmSlug)
        //       .collection("matters")
        //       .doc(this.matter.matterSlug)
        //       .collection("notes")
        //       .doc(id)
        //       .update({
        //         id: id
        //       })
        //       .then(() => {
        //         console.log(
        //           "added note -- MUST ADD THIS TO ACTIVITIES LIST AS WELL"
        //         );
        //       })
        //       .catch(e => {
        //         console.error(e);
        //       });
        // let oldMatter = this.matter;
        // let newMatter = Object.assign(oldMatter);
        // let notes;
        // if (this.matter.notes) {
        //   notes = this.matter.notes;
        //   console.log(notes);
        // } else {
        //   console.log("this.matter has no notes array");
        //   // newMatter = Object.assign(this.matter);
        //   console.log("newMatter", newMatter);
        //   newMatter.notes = [];
        //   console.log("newMatter with notes array", newMatter);
        //   console.log("oldMAtter", oldMatter);
        // }
        // newMatter.notes.unshift(note);
        // console.log("newMatter with note", newMatter);
        // let newNoteList = Array.from(this.matter.notes);
        // console.log(newNoteList);
        // newNoteList.unshift(note);
        // console.log(newNoteList);
        let array;
        let notes = [];
        if (this.matter.notes) {
          // array = Array.from(this.matter.notes);
          array = Array.from(this.matter.notes);
          array.unshift(note);
          firebase
            .firestore()
            // .collection("firms")
            // .doc(this.user.firmSlug)
            .collection("matters")
            .doc(this.matter.matterSlug)
            .update({
              // notes: firebase.firestore.FieldValue.arrayUnion(note)
              notes: array
            })
            .then(() => {
              console.log("added note ");
              this.content = null;
              this.tags = [];
              this.dialog = false;
            })
            .catch(e => {
              console.error(e);
            });
        } else {
          notes.push(note);
          firebase
            .firestore()
            // .collection("firms")
            // .doc(this.user.firmSlug)
            .collection("matters")
            .doc(this.matter.matterSlug)
            .update({
              // notes: firebase.firestore.FieldValue.arrayUnion(note)
              notes: notes
            })
            .then(() => {
              console.log("added note ");
              this.content = null;
              this.tags = [];
              this.dialog = false;
            })
            .catch(e => {
              console.error(e);
            });
        }
        // this.matter.notes.unShift(note);

        // firebase
        //   .firestore()
        //   .collection("firms")
        //   .doc(this.user.firmSlug)
        //   .collection("matters")
        //   .doc(this.matter.matterSlug)
        //   .update({
        //     // notes: firebase.firestore.FieldValue.arrayUnion(note)
        //     notes: array
        //   })
        //   .then(() => {
        //     console.log("added note ");
        //     this.content = null;
        //     this.tags = [];
        //     this.dialog = false;
        //   })
        //   .catch(e => {
        //     console.error(e);
        //   });

        // });
      }
    },
    cancelDialog() {
      this.content = null;

      this.tags = [];
      this.dialog = false;
    }
  }
};
</script>

<style lang="scss" scoped></style>
